import { render, staticRenderFns } from "./MyOrderListDesktop.vue?vue&type=template&id=11481226&scoped=true"
import script from "./MyOrderListDesktop.vue?vue&type=script&lang=js"
export * from "./MyOrderListDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11481226",
  null
  
)

export default component.exports